export function dateFormatterEst(
  date: Date | null | string | undefined,
): string {
  if (!date) return "";

  const dateObj = new Date(date);

  const formatter = Intl.DateTimeFormat("en-US", {
    day: "numeric",
    month: "short",
    timeZone: "America/New_York",
    year: "numeric",
  });

  return formatter.format(dateObj);
}
